export class ProvinceResult {
    public id: number = 0;
    public name: string = '';
    public countryId: number = 0;
    public countryName: string = '';
}
